
export const handleProfileImageCrop = (croppedImage: any, setFieldValue: Function, seImageView: Function) => {
    seImageView(URL.createObjectURL(croppedImage));
    setFieldValue("profile_pic", croppedImage);
}